var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "pay-qr trans-qr"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "qr-img in-pc"
  }, [_c('div', {
    class: 'ic_' + _vm.iconName
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.qrsrc
    },
    on: {
      "load": _vm.onImageLoad
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }]
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.tips
    }
  })])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-f34afc26","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/payment/PayQr.vue
// module id = 258
// module chunks = 0